import React from "react";
import { useNavigate } from "react-router-dom";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { AnalyticsAlert } from "../analyticsApi";

const STYLE = {
  critical: {
    cls: "bg-rose-50 text-rose-700 border-rose-200 hover:bg-rose-100 dark:bg-rose-900/30 dark:text-rose-300 dark:border-rose-800/60 dark:hover:bg-rose-900/50",
    Icon: ErrorOutlineIcon,
  },
  warning: {
    cls: "bg-amber-50 text-amber-700 border-amber-200 hover:bg-amber-100 dark:bg-amber-900/30 dark:text-amber-300 dark:border-amber-800/60 dark:hover:bg-amber-900/50",
    Icon: WarningAmberIcon,
  },
  info: {
    cls: "bg-slate-100 text-slate-700 border-slate-200 hover:bg-slate-200 dark:bg-slate-700/60 dark:text-slate-200 dark:border-slate-600 dark:hover:bg-slate-700",
    Icon: InfoOutlinedIcon,
  },
};

export const ANALYTICS_BASE = "/client/analytics";

/** Severity-coloured chips; each one opens the tab the alert belongs to. */
export default function AlertsStrip({ alerts }: { alerts: AnalyticsAlert[] }) {
  const navigate = useNavigate();
  if (!alerts || alerts.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-2" role="list" aria-label="Alerts">
      {alerts.map((alert) => {
        const { cls, Icon } = STYLE[alert.severity] ?? STYLE.info;
        return (
          <button
            key={alert.key}
            type="button"
            role="listitem"
            onClick={() => navigate(`${ANALYTICS_BASE}/${alert.tab}`)}
            className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-medium text-left transition-colors ${cls}`}
            title={`Open ${alert.tab}`}
          >
            <Icon sx={{ fontSize: 14 }} />
            <span>{alert.message}</span>
          </button>
        );
      })}
    </div>
  );
}
